import React, { useContext, useCallback, useState } from "react";

import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { StateContext as HomeStateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import AppointmentDtlPop from "./appointmentDtlPop";
import CsDtlPop from "./csDtlPop";
import OtDtlPop from "./otDtlPop";
import EtDtlPop from "./etDtlPop";
import ClassDtlPop from "./classDtlPop";
import ScheduleInfo from "./scheduleInfo";
import ConditionConfirmCs from "./conditionConfirmCs";
import ConditionConfirmEt from "./conditionConfirmEt";
import ConditionConfirmOt from "./conditionConfirmOt";
import EditEtcCalendar from "bodycodi/cmap/app/components/cmap2040/editEtcCalendar";
import EditEtcTimePicker from "bodycodi/cmap/app/components/cmap2040/editEtcTimePicker";

const ScheduleDtlPopWrap = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "SCHEDULE_DTL_POP", open: { scheduleDtlPop: false } });
  };

  return (
    <CustomDialog open={state.scheduleDtlPop} onClose={handleClose}>
      {state.scheduleDtlPop && <ScheduleDtlPop />}
    </CustomDialog>
  );
};

const ScheduleDtlPop = () => {
  const { state } = useContext(HomeStateContext);
  const [data, setData] = useState<any>({
    scheduleType: "",
    seqSchedule: "",
    time: {},
    center: {},
    chooseDate: {},
    member: {},
    scheduleName: "",
    csDecs: "",
    editStep: 1,
  });
  const [startTime, setStartTime] = useState({});
  const [endTime, setEndTime] = useState({});
  const [refresh, setRefresh] = useState(1);
  const [isAvailableTime, setIsAvailableTime] = useState<boolean>(true);

  const updateData = (d: any) => {
    setData((previousValue: any) => ({
      ...previousValue,
      ...d,
    }));
  };

  const update = useCallback(() => {
    setRefresh(refresh + 1);
  }, [refresh]);

  return (
    <>
      {state.scheduleDtlPop.scheduleType.toLowerCase() === "appointment" && (
        <>
          {state.scheduleDtlPop.appointmentClCd.toLowerCase() === "ot" && (
            <OtDtlPop
              updateData={updateData}
              refresh={refresh}
              setStartTime={setStartTime}
              setEndTime={setEndTime}
            />
          )}
          {state.scheduleDtlPop.appointmentClCd.toLowerCase() === "cs" && (
            <CsDtlPop
              updateData={updateData}
              refresh={refresh}
              setStartTime={setStartTime}
              setEndTime={setEndTime}
            />
          )}
          {state.scheduleDtlPop.appointmentClCd.toLowerCase() === "et" && (
            <EtDtlPop
              updateData={updateData}
              refresh={refresh}
              setStartTime={setStartTime}
              setEndTime={setEndTime}
            />
          )}
          {!(
            state.scheduleDtlPop.appointmentClCd.toLowerCase() === "et" ||
            state.scheduleDtlPop.appointmentClCd.toLowerCase() === "ot" ||
            state.scheduleDtlPop.appointmentClCd.toLowerCase() === "cs"
          ) && <AppointmentDtlPop />}
        </>
      )}
      {state.scheduleDtlPop.scheduleType.toLowerCase() === "class" && <ClassDtlPop />}

      <EditEtcCalendar
        scheduleType={data.scheduleType}
        chooseDate={data.chooseDate}
        data={data}
        updateData={updateData}
      >
        <ScheduleInfo data={data} updateData={updateData} startTime={startTime} endTime={endTime} />
      </EditEtcCalendar>

      <EditEtcTimePicker
        scheduleType={data.scheduleType}
        chooseDate={data.chooseDate}
        startTime={startTime}
        endTime={endTime}
        data={data}
        updateData={updateData}
        setStartTime={setStartTime}
        setEndTime={setEndTime}
        isAvailableTime={isAvailableTime}
        setIsAvailableTime={setIsAvailableTime}
      >
        <ScheduleInfo data={data} updateData={updateData} startTime={startTime} endTime={endTime} />
      </EditEtcTimePicker>

      <ConditionConfirmOt
        {...data}
        update={update}
        startTime={startTime}
        endTime={endTime}
        updateData={updateData}
      />
      <ConditionConfirmCs
        {...data}
        update={update}
        startTime={startTime}
        endTime={endTime}
        updateData={updateData}
      />
      <ConditionConfirmEt
        {...data}
        update={update}
        startTime={startTime}
        endTime={endTime}
        updateData={updateData}
      />
    </>
  );
};

export default ScheduleDtlPopWrap;
